import React from "react";
import { Box, Typography } from "@mui/material";
import { WarningAmber as WarningIcon } from "@mui/icons-material";

const BetaBanner = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#ffcc00",
        color: "#000",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        py: 0.8,
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 2000,
        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
      }}
    >
      <WarningIcon sx={{ fontSize: 20 }} />
      <Typography variant="body2" fontWeight={600}>
        You are using the <strong>Beta Version</strong> of eRespiroConnect
      </Typography>
    </Box>
  );
};

export default BetaBanner;
